import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Image,
  List,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from 'semantic-ui-react';

function KtpImagePreviewModal({ ktp, open, onClose }) {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalHeader>KTP Details</ModalHeader>
      <ModalContent>
        <List>
          <List.Item>
            <strong>KTP Number:</strong> {ktp.number}
          </List.Item>
          <List.Item>
            <strong>KTP Name:</strong> {ktp.name}
          </List.Item>
        </List>
        {!!ktp.image && <Image src={ktp.image} size="large" />}
      </ModalContent>
      <ModalActions>
        <Button primary onClick={onClose}>
          Close
        </Button>
      </ModalActions>
    </Modal>
  );
}

KtpImagePreviewModal.propTypes = {
  ktp: PropTypes.shape({
    name: PropTypes.string,
    number: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default KtpImagePreviewModal;
